<template>
    <div class="goods">
        <van-nav-bar title="账号绑定" style="height: 1.28rem"/>

        <div>
            <van-cell-group>
                <van-field class="flex-start" v-model="phone" type="number" maxlength="11" placeholder="请输入手机号" @input="toMember" onfocus="this.placeholder=' '" onblur="this.placeholder='请输入手机号'"><template v-slot:right-icon><div style="position: absolute;left: 0;top: 0;">+86</div></template></van-field>
                <van-field class="flex-start" v-model="checkCode" type="number" maxlength="6" placeholder="请输入验证码" @input="toMember2" onfocus="this.placeholder=' '" onblur="this.placeholder='请输入验证码'">
                    <template v-slot:right-icon>
                        <div v-if="show2==true" class="send active" @click="sendCodec">{{sendCode}}</div>
                        <div v-else class="send" @click="sendCodec">{{sendCode}}</div>
                    </template>
                </van-field>
            </van-cell-group>
        </div>

        <div>
            <div class="flex-center" style="width: 100%;padding-bottom: .378rem;">
                <div v-if="show3==true" class="flex-center btn1 btn3" @click="toSucceed">提交</div>
                <div v-else class="flex-center btn1 btn2">提交</div>
            </div>
        </div>

    </div>
</template>

<script>
    import {
        NavBar,
        Picker,
        Popup,
        Icon,
        Field,
        CellGroup,
        Image,
        Toast
    } from 'vant';

    import request from '@/utils/request'

    export default {
        components: {
            [NavBar.name]: NavBar,
            [Picker.name]: Picker,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [CellGroup.name]: CellGroup,
            [Image.name]: Image,
            [Toast.name]: Toast
        },

        data() {
            return {
                token:"",
                phone:"",
                checkCode:"",

                code:"",
                state:"",

                shopList:[],
                shopListStatus:0,
                shopListId:"",
                show: false,
                show2: false,
                show3: false,
                show4: false,
                sendCode:"发送验证码"
            };
        },

        methods: {
            //输入电话
            toMember(val) {
                let _this=this;
                let phone=_this.phone;
                if(val.length == 0){
                    _this.show2=false;
                }else{
                    _this.show2=true;
                }
            },
            //输入验证码
            toMember2(val) {
                let _this=this;
                let checkCode=_this.checkCode;
                if(val.length == 0){
                    _this.show3=false;
                }else{
                    _this.show3=true;
                }
            },
            //提交
            toSucceed() {
                var _this=this;
                var phone=_this.phone;
                var checkCode=_this.checkCode;

                if(phone == ""){
                    Toast('请输入手机号')
                    return false;
                }else if(checkCode == ""){
                    //alert("请选择车龄")
                    Toast('请输入验证码')
                    return false;
                }

                var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
                if (!myreg.test(phone)) {
                    Toast('手机号有误')
                    return false;
                }else if (phone.length < 11) {
                    Toast('手机号长度有误')
                    return false;
                }

                request({
                    url: '/public/portal/login/auth',
                    method: 'POST',
                    data:{
                        code:_this.code,
                        state:_this.state,
                        mobile:phone,
                        checkCode:checkCode,
                    }
                }).then(res=>{
                    if(res.code==200){
                        Toast('账号绑定成功')
                    }else{
                        Toast(res.msg)
                    }
                });

            },

            //点击验证码
            sendCodec(){
                var _this=this;
                if(_this.show4==true){
                    Toast('验证码获取太频繁,请稍后');
                    return false;
                }
                _this.show4=true;
                var phone=_this.phone;

                if(phone == ""){
                    Toast('请输入手机号')
                    return false;
                }

                var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
                if (!myreg.test(phone)) {
                    Toast('手机号有误')
                    return false;
                }else if (phone.length < 11) {
                    Toast('手机号长度有误')
                    return false;
                }

                request({
                    url: '/public/portal/check_code',
                    method: 'GET',
                    data:{
                        mobile:phone
                    }
                }).then(res=>{
                    _this.show4=false;
                    if(res.code == 200){
                        Toast('发送成功');
                        _this.show=!_this.show;
                        _this.TheBottom(60);
                    }
                });
            },

            //倒数
            TheBottom(c){
                var _this=this;
                c=c-1;
                if(c==0){
                    _this.sendCode="重新发送";
                    _this.show=!_this.show;
                    return false;
                }
                _this.sendCode="重新发送（"+c+"s）";
                setTimeout(function () {
                    _this.TheBottom(c);
                },1000);
            }

        },
        mounted: function () {
            var _this = this;
            var url2=window.location.href;

            // var url2="http://webapp.daihing.yn-ce.com/?code=061hU13d1PisRv0Nlw2d1ynb3d1hU13X&state=1#/AccountBinding?mobile=18282522397";
            let arr;
            arr = url2.split("?");
            arr = arr[1].split("#");
            var data=arr[0].split("&");
            var code=data[0].split("=");
            code=code[1];
            var state=data[1].split("=");
            state=state[1];
            _this.code=code;
            _this.state=state;
            //alert(code)
            //alert(state)
        }
    };
</script>

<style lang="less">
    .goods {
        padding-bottom: 0 !important;

        &-swipe {
            img {
                width: 100%;
                display: block;
            }
        }

        &-title {
            font-size: 16px;
        }

        &-price {
            color: #f44;
        }

        &-express {
            color: #999;
            font-size: 12px;
            padding: 5px 15px;
        }

        &-cell-group {
            margin: 15px 0;

            .van-cell__value {
                color: #999;
            }
        }

        &-tag {
            margin-left: 5px;
        }
    }

    body{
        background: #fff;
    }
    .flex-start{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:flex-start;
    }
    .flex-center{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:center;
    }
    .flex-column{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .van-nav-bar__title{
        font-size: .486rem;
        color: #333;
    }
    .van-nav-bar .van-icon{
        font-size: .486rem;
        color: #333;
    }
    .van-cell-group{
        padding: 0 .6rem;
        margin: .5rem 0 1rem;
        position: relative;
    }
    .van-cell{
        height: 1.377rem;
        font-size: 0.378rem;
        padding: 0;
        /*padding-right: .405rem;*/
        border-bottom: 1px solid #F2F2F2;
    }
    .van-cell-group .van-cell:nth-child(1) .van-field__control{
        padding-left: 1.1rem;
    }
    .btn1{
        background: #FED0AE;
        color: #FFEFE3;
        font-size: .432rem;
        width: 90%;
        height: 1.188rem;
        border-radius: .594rem;
        font-weight:500;
    }
    .btn2{
        background: #FED0AE;
        color: #FFEFE3;
    }
    .btn3{
        background: #E69A61;
        color: #fff;
    }
    .active{
        color: #E69A61;
    }
</style>

